// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2j-1";
export var movingGradient = "_2j-4";
export var movingGradientBlock = "_2j-2";
export var skeleton = "_2j-0";
export var skeletonText = "_2j-3";